import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from './swal';
import RoadiesShell from './RoadiesShell';
import { GameHead, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';

// s1.php: three pillows, one hides the mistletoe (random 1-3). You pick one — one chance only.
function Stage1Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const session = useSelector((s) => s.roadies.session);
  const rotate = useRotateNotice();
  const timer = useGameTimer(true, '00:00'); // stage 1 always starts the clock from 0
  const save = useSaveScore();

  const winner = useRef(1 + Math.floor(Math.random() * 3)); // the winning pillow index (1-3)
  const opened = useRef(false);
  const [src, setSrc] = useState(['pillow', 'pillow', 'pillow']);
  const [points, setPoints] = useState(0);

  const pick = async (pos) => {
    if (opened.current) return;
    opened.current = true;
    const won = pos === winner.current - 1;
    const next = ['empty', 'empty', 'empty'];
    next[winner.current - 1] = 'fill';
    setSrc(next);
    const score = won ? 1 : 0;
    setPoints(score);

    await Swal.fire('', won ? 'You have got it right!' : 'Oops, you got it wrong!', won ? 'success' : 'error');

    if (session?.sessionId === 'demobypass') {
      await save(1, score, timer.current(), { quiet: true });
      Swal.fire({ title: 'Subscribe to any PLAN to play with your peers.', icon: 'info', allowOutsideClick: false });
      setTimeout(() => {
        window.location.href = `${process.env.REACT_APP_BASE_URL}/plans`;
      }, 3000);
      return;
    }

    const state = await save(1, score, timer.current());
    if (state) navigate({ pathname: '/stage2', search });
  };

  return (
    <>
      {rotate && (
        <div className="rd-rotate">Please rotate your device for the best experience</div>
      )}
      <TopBar time={timer.text} points={points} />
      <GameHead
        title="Ireland"
        highlight="Tap on the below to find the mistletoe. You have one chance only!"
      >
        Single women in Ireland sometimes place a mistletoe (a berry associated with fertility in European
        mythology) under their pillow. They then burn it in a fire the next day in the hope of luring in love
        over the year.
      </GameHead>
      <div className="rd-pillows">
        {src.map((img, i) => (
          <img
            key={i}
            src={`/roadies/img/s1/${img}.png`}
            className="rd-pillow"
            alt={`Pillow ${i + 1}`}
            onClick={() => pick(i)}
          />
        ))}
      </div>
    </>
  );
}

export default function RoadiesStage1() {
  return (
    <RoadiesShell bg="ireland.jpg" bgMob="ireland-mob.jpg" stage={1} className="rd-stage rd-stage1">
      <Stage1Game />
    </RoadiesShell>
  );
}
